import React from 'react'

import Headings from '@/components/BookLandingPageComp/landingPage/heading'
import RenderIf from '@/components/Common/RenderIf'


interface PublicationDetailsProps {
  isOrange?: boolean;
  landingPageData: any
}

const PublicationDetails = ({ isOrange = false, landingPageData }: PublicationDetailsProps) => {
  const publicationRows = [
    { label: 'Publisher', value: landingPageData?.form?.publisher },
    { label: 'Published', value: landingPageData?.form?.published_at },
    { label: 'ISBN-13', value: landingPageData?.form?.isbn },
  ].filter((row) => Boolean(row.value));

  return (
    <RenderIf condition={isOrange && publicationRows.length > 0}>
      <div className=''>
        <Headings heading='Publication Details' />
        <div
          className='mt-4 rounded-lg overflow-hidden'
          style={{
            border: '1px solid rgba(255, 255, 255, 0.14)',
            background: 'radial-gradient(67.49% 179.15% at 50% 50.31%, rgb(15, 15, 15) 0%, rgb(45, 45, 45) 100%)',
          }}
        >
          {publicationRows.map((row, index, arr) => (
            <div
              key={row.label}
              className='flex items-center'
              style={{
                borderBottom: index < arr.length - 1 ? '1px solid rgba(255, 255, 255, 0.14)' : 'none',
              }}
            >
              <div className='sm:px-7 px-3 py-2.5 w-1/2' style={{ borderRight: '1px solid rgba(255, 255, 255, 0.14)' }}>
                <p className='text-grayZl-500 sm:text-sm text-xs font-normal truncate'>{row.label}</p>
              </div>
              <div className='sm:px-7 px-3 py-2.5 w-1/2'>
                <p className='text-grayZl-500 sm:text-sm text-xs font-normal truncate'>{row.value}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </RenderIf>
  )
}

export default PublicationDetails